const checkForLoader = () => {
  // Check for the loader using both the component class and potential wrapper elements
  return !!(
    document.querySelector('.bs-bounce-spin-loader') ||
    document.querySelector('.cube-wrapper')
  );
};

export const waitForPageLoad = () => {
  return new Promise((resolve) => {
    const checkLoadingComplete = () => {
      if (document.readyState !== 'complete') {
        return false;
      }

      // Check if loader is present
      if (checkForLoader()) {
        return false;
      }

      return true;
    };

    const checkStatus = () => {
      if (checkLoadingComplete()) {
        // Add a small delay for any final DOM updates
        setTimeout(resolve, 1000);
      } else {
        // Check again in a short interval
        setTimeout(checkStatus, 100);
      }
    };

    // Start checking
    checkStatus();

    // Also listen for load event in case page isn't loaded yet
    window.addEventListener(
      'load',
      () => {
        // After load, continue checking for loader
        checkStatus();
      },
      { once: true }
    );
  });
};
